import { useFloatingParentNodeId } from '@floating-ui/react';
export function useIsNested() {
  const parentId = useFloatingParentNodeId();
  return parentId !== null;
}